import React, { useEffect, useRef } from "react";
import injectSheet from "react-jss";
import classNames from "classnames";

const Popup = (props) => {
  const { classes, children, isOpen, className, contentStyle, arrowStyle, id } =
    props;
  const node = useRef();

  const handleClose = (e) => {
    if (e.target === node && props.handleClose) {
      props.handleClose();
    }
  };

  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      return;
    }
    // outside click
    if (props.doNotHandleClickOutside) {
      return;
    }
    if (isOpen) {
      props.handleClose(e);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [isOpen]);

  return (
    <div
      className={classNames(classes.popup, className)}
      style={isOpen ? { display: "flex" } : null}
    >
      {!props.position || props.position === "bottom" ? (
        <>
          <div className={classNames(classes.arrow, arrowStyle)} />
          <div
            id={id}
            ref={node}
            onClick={handleClose}
            className={classNames(classes.content, contentStyle)}
          >
            {children}
          </div>
        </>
      ) : (
        props.position === "right" && (
          <>
            <div className={classNames(classes.arrowRight, arrowStyle)} />
            <div
              ref={node}
              onClick={handleClose}
              className={classes.contentRight}
            >
              {children}
            </div>
          </>
        )
      )}
    </div>
  );
};

const styles = {
  popup: {
    position: "relative",
    transition: "opacity 500ms",
    zIndex: "9997",
    display: "none",
    marginLeft: (props) => (props.marginLeft ? props.marginLeft : null),
    "@media (max-width: 1023px)": {
      display: "none",
      alignItems: "center",
      justifyContent: "center",
      position: "fixed",
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      paddingLeft: "9px",
      paddingRight: "9px",
      paddingBottom: "9px",
      paddingTop: (props) => (props.paddingTop ? props.paddingTop : "20px"),
      backgroundColor: "rgba(55, 55, 55, 0.3)",
      overflowX: "hidden",
      overflowY: "auto",
    },
  },
  arrow: {
    backgroundColor: "white",
    borderColor: "#dbe0e8",
    borderStyle: "solid",
    borderWidth: "1px 0 0 1px",
    width: "10px",
    height: "10px",
    position: "absolute",
    transform: "rotate(45deg)",
    top: (props) => (props.top === "inside" ? "calc(-5px * 2)" : 0),
    right: (props) => (props.right ? "10px" : null),
    left: (props) => (props.left ? "10px" : null),
    zIndex: "10001",
    "@media (max-width: 1023px)": {
      display: "none",
    },
  },
  arrowRight: {
    backgroundColor: "white",
    borderColor: "#dbe0e8",
    borderStyle: "solid",
    borderWidth: "1px 0 0 1px",
    width: "10px",
    height: "10px",
    position: "absolute",
    transform: "rotate(-45deg)",
    bottom: (props) =>
      props.arrowPositionBottom ? props.arrowPositionBottom : "25px",

    left: (props) => (props.left ? "calc(" + props.left + " - 5px)" : null),
    zIndex: "9998",
    "@media (max-width: 1023px)": {
      display: "none",
    },
  },
  content: {
    width: (props) => props.width,
    height: (props) => props.height,
    top: (props) => (props.top === "inside" ? "-5px" : "5px"),
    bottom: (props) => props.bottom,
    right: (props) => props.right,
    left: (props) => props.left,
    transition: "all 0.15s ease-out",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: (props) => (props.borderColor ? props.borderColor : "#dbe0e8"),
    position: "absolute",
    backgroundColor: (props) =>
      props.backgroundColor ? props.backgroundColor : "white",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0), 0 6px 12px 0 rgba(0, 0, 0, 0.1)",
    "@media (max-width: 1023px)": {
      left: "0 !important",
      top: "0 !important",
      position: "static",
      width: "100% !important",
      overflowY: (props) => (props.dontSetOverflowY ? null : "auto"),
      maxHeight: "100% !important",
      zIndex: 10001,
    },
  },
  contentRight: {
    width: (props) => props.width,
    //height: props => props.height,
    maxHeight: (props) => props.height,
    top: (props) => props.top,
    bottom: (props) => props.bottom,
    right: (props) => props.right,
    left: (props) => props.left,
    transition: "all 0.15s ease-out",
    borderWidth: "1px",
    borderStyle: "solid",
    overflowY: (props) => (props.overflowY ? props.overflowY : null),
    borderColor: (props) => (props.borderColor ? props.borderColor : "#dbe0e8"),
    position: "absolute",
    backgroundColor: (props) =>
      props.backgroundColor ? props.backgroundColor : "white",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0), 0 6px 12px 0 rgba(0, 0, 0, 0.1)",
    "@media (max-width: 1023px)": {
      left: "0 !important",
      top: "0 !important",
      position: "static",
      width: "100% !important",
      overflowY: (props) => (props.dontSetOverflowY ? null : "auto"),
      maxHeight: "100% !important",
      opacity: 1,
      zIndex: 10001,
    },
  },
};
export default injectSheet(styles)(Popup);
